// extracted by mini-css-extract-plugin
export default {"root":"designer_root__3yA5S"};